import React from "react";
import NaviLogo from "./shared/NaviLogo";
import BasketNavButton from "./shared/BasketNavButton";
import NaviLinks from "./shared/NaviLinks";
import LanguageSelect from "../LanguageSelect";

const HorizontalNavBar: React.FC = () => {
  return (
    <nav className="horizontal-navbar" data-testid="horizontal-navbar">
      <NaviLogo />
      <LanguageSelect />
      <NaviLinks collapseOverflow />
      <BasketNavButton fullwidth={false} />
    </nav>
  );
};

export default HorizontalNavBar;
 